// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.5.5_@swc+helpers@0.5.11__webpack@5.101.3_@swc+core@1.4.17_@swc+helpers@0.5.11__/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.5.5_@swc+helpers@0.5.11__webpack@5.101.3_@swc+core@1.4.17_@swc+helpers@0.5.11__/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.antd-img-crop-modal .ant-modal-body {
  padding-bottom: 16px;
}
.antd-img-crop-modal .antd-img-crop-container {
  position: relative;
  width: 100%;
  height: 40vh;
  margin-bottom: 16px;
}
.antd-img-crop-modal .antd-img-crop-control {
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-size: 16px;
  margin: 0 16px;
}
.antd-img-crop-modal .antd-img-crop-control.zoom,
.antd-img-crop-modal .antd-img-crop-control.rotate {
  flex: 4;
}
.antd-img-crop-modal .antd-img-crop-control.flip {
  flex: 2;
  min-width: 48px;
}
.antd-img-crop-modal .antd-img-crop-control .ant-slider {
  flex: 1;
  margin: 0 8px 0 12px;
  min-width: 120px;
}
`, "",{"version":3,"sources":["webpack://./../ui/src/components/ImageCrop/index.less"],"names":[],"mappings":"AAAA;EAEI,oBAAA;AAAJ;AAFA;EAMI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AADJ;AARA;EAaI,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;AAFJ;AAII;;EAEE,OAAA;AAFN;AAKI;EACE,OAAA;EACA,eAAA;AAHN;AAvBA;EA8BM,OAAA;EACA,oBAAA;EACA,gBAAA;AAJN","sourcesContent":[".antd-img-crop-modal {\n  .ant-modal-body {\n    padding-bottom: 16px;\n  }\n\n  .antd-img-crop-container {\n    position: relative;\n    width: 100%;\n    height: 40vh;\n    margin-bottom: 16px;\n  }\n\n  .antd-img-crop-control {\n    display: flex;\n    justify-content: space-around;\n    align-items: center;\n    font-size: 16px;\n    margin: 0 16px;\n\n    &.zoom,\n    &.rotate {\n      flex: 4;\n    }\n\n    &.flip {\n      flex: 2;\n      min-width: 48px;\n    }\n\n    .ant-slider {\n      flex: 1;\n      margin: 0 8px 0 12px;\n      min-width: 120px;\n    }\n  }\n}\n\n@badge-height: 16px;@badge-font-size: 9.6px;@fill-body: #FFFFFF;@menu-collapsed-width: 64px;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
